import { useEffect } from 'react';
import { useFieldArray, useWatch } from 'react-hook-form';
import { SUB_ACCOUNT_DRAFT } from '../utils/constants';

const usePropagateAccountIdentifiers = (
    accountId,
    {
        control,
        setValue,
        getValues,
        validate = false,
        dirty = false,
        touch = false
    }
) => {
    const { update } = useFieldArray({
        control,
        name: "subAccounts",
    });

    const watchedValues = useWatch({
        control,
        name: ['accountName', 'accountHccId']
    });

    const [accountName, accountHccId] = watchedValues;

    useEffect(() => {
        const subAccounts = getValues("subAccounts");
        const subAccountDraft = getValues(SUB_ACCOUNT_DRAFT);

        subAccounts.forEach((subAccount, index) => {
            if (subAccount.parentAccount.key === accountId) {
                const newParentAccount = {
                    ...subAccount.parentAccount,
                    value: accountHccId,
                    label: `${accountName} (${accountHccId})`
                };
                update(index, { ...subAccount, parentAccount: newParentAccount });
            }
        });
        
        if (subAccountDraft.parentAccount?.key === accountId) {
            const newParentAccount = {
                ...subAccountDraft.parentAccount,
                value: accountHccId,
                label: `${accountName} (${accountHccId})`
            };
            setValue(`${SUB_ACCOUNT_DRAFT}.parentAccount`, newParentAccount, {
                shouldValidate: validate,
                shouldDirty: dirty,
                shouldTouch: touch
            });
        }
    }, [accountName, accountHccId]);

    return {};
};

export default usePropagateAccountIdentifiers;
